import { useQuery } from 'react-query'
import { getVerify } from 'services/easyPay'

export default function useGetVerifyTransactions() {
    const transactions = JSON.parse(
        localStorage.getItem('toBePaidTransactions')!
    )
    const { data, isLoading } = useQuery(
        ['get-verify-transactions', transactions?.pk],
        getVerify
    )
    return { data, isLoading }
}
